/**
 * Copyright (C) 2019 Egylis,
 * Siège social, 83 bis rue de l'Abbé Groult, 75015 Paris - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created by calvez on 16/05/2019.
 *
 * Version : Generator 2.0.9
 */

/**
 * Synchronization Stream Status Enum
 */
export enum SynchroStreamStatus {
    /**
     * Start Synchro
     */
    START_SYNCHRO = <any>'START_SYNCHRO',
    /**
     * Already Syncing : one synchro is already started
     */
    ALREADY_SYNCING = <any>'ALREADY_SYNCING',
    /**
     * Send Data
     */
    SEND_DATA = <any>'SEND_DATA',
    /**
     * Send Data Info
     */
    SEND_DATA_INFO = <any>'SEND_DATA_INFO',
    /**
     * Send File
     */
    SEND_FILE = <any>'SEND_FILE',
    /**
     * Send File Info
     */
    SEND_FILE_INFO = <any>'SEND_FILE_INFO',
    /**
     * Send File Info Progress
     */
    SEND_FILE_INFO_PROGRESS = <any>'SEND_FILE_INFO_PROGRESS',
    /**
     * Get Data
     */
    GET_DATA = <any>'GET_DATA',
    /**
     * Get Data Info
     */
    GET_DATA_INFO = <any>'GET_DATA_INFO',
    /**
     * Get File
     */
    GET_FILE = <any>'GET_FILE',
    /**
     * Get Data Info
     */
    GET_FILE_INFO = <any>'GET_FILE_INFO',
    /**
     * Get Data Info Progress
     */
    GET_FILE_INFO_PROGRESS = <any>'GET_FILE_INFO_PROGRESS',
    /**
     * Error DexieJs
     */
    ERROR_DEXIE = <any>'ERROR_DEXIE',
    /**
     * Error Cordova FileTransfer Get
     */
    ERROR_CORDOVA_FILETRANSFER_GET = <any>'ERROR_CORDOVA_FILETRANSFER_GET',
    /**
     * Error Cordova FileTransfer POST
     */
    ERROR_CORDOVA_FILETRANSFER_POST = <any>'ERROR_CORDOVA_FILETRANSFER_POST',
    /**
     * Error Cordova File Save
     */
    ERROR_CORDOVA_FILE_SAVE = <any>'ERROR_CORDOVA_FILE_SAVE',
    /**
     * Error Http Get
     */
    ERROR_HTTP_GET = <any>'ERROR_HTTP_GET',
    /**
     * Error Http Post
     */
    ERROR_HTTP_POST = <any>'ERROR_HTTP_POST',
    /**
     * Error Mpa
     */
    ERROR_MPA = <any>'ERROR_MPA',
    /**
     * Connectivity Ok
     */
    CONNECTIVITY_OK = <any>'CONNECTIVITY_OK',
    /**
     * Connectivity Ko
     */
    CONNECTIVITY_KO = <any>'CONNECTIVITY_KO',
    /**
     * Stop Synchro : ask by user
     */
    END_BY_STOP_SYNCHRO = <any>'END_BY_STOP_SYNCHRO',
    /**
     * Error Synchro : ask by user
     */
    END_BY_ERROR_SYNCHRO = <any>'END_BY_ERROR_SYNCHRO',
    /**
     * End Synchro : normally end
     */
    END_NORMAL_SYNCHRO = <any>'END_NORMAL_SYNCHRO'
}
